<template>
  <a-modal
    :visible="visible"
    :title="category ? '修改分类' : '添加新的分类'"
    :okText="category ? '保存' : '添加'"
    cancelText="取消"
    @cancel="$emit('cancel')"
    @ok="onSubmit"
  >
    <a-form-model layout="vertical" ref="form" :model="form" :rules="rules">
      <a-form-model-item ref="name" label="类名" prop="name">
        <a-input v-model="form.name" @pressEnter="onSubmit" />
      </a-form-model-item>

      <a-form-model-item ref="color" label="颜色" prop="color">
        <a-input v-model="form.color" @pressEnter="onSubmit">
          <a-dropdown slot="suffix" placement="bottomRight">
            <div
              class="color__block"
              :style="
                `width:2rem;height:2rem;background-color:${form.color};border-radius: 10rem;`
              "
            ></div>
            <chrome-picker
              @input="selectColor"
              v-model="form.color"
              slot="overlay"
              :palette="palette"
            ></chrome-picker>
          </a-dropdown>
          <a-dropdown slot="prefix" placement="bottomLeft">
            <div
              class="color__block"
              :style="
                `width:1.5rem;height:1.5rem;background-color:${form.color};border-radius: 10rem;`
              "
            ></div>
            <compact-picker
              @input="selectColor"
              v-model="form.color"
              slot="overlay"
              :palette="palette"
              style="width: 8.5rem;"
            ></compact-picker>
          </a-dropdown>
        </a-input>
      </a-form-model-item>
      <a-form-model-item ref="description" label="描述" prop="description">
        <a-input v-model="form.description" @pressEnter="onSubmit" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
//TODO 提交更新的逻辑移到这里算了，为啥要在上一层整
import { Compact, Chrome } from "vue-color";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["visible", "category"],
  components: {
    "compact-picker": Compact,
    "chrome-picker": Chrome
  },
  data() {
    return {
      palette: [
        "#f14ba9",
        "#f76964",
        "#ff8800",
        "#ffc60a",
        "#34c724",
        "#00d6b9",
        "#4e83fd",
        "#14c0ff",
        "#616ae5",
        "#935af6",
        "#d136d1",
        "#8f959e"
      ],
      rules: {
        name: [
          { required: true, message: "请输入分类名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              for (let id in this.categorys) {
                if (!this.category && this.categorys[id].name === value)
                  callback("已有相同名字的分类");
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        color: [
          {
            required: true,
            message: "请输入颜色",
            trigger: "change"
          },
          {
            pattern: /^#([a-fA-F\d]{6}|[a-fA-F\d]{3})$/,
            message: "请输入HEX格式色码！如:#FFC60A",
            trigger: "change"
          }
        ]
      },
      form: {
        color: "#FFC60A",
        name: "",
        description: ""
      }
    };
  },
  computed: {
    ...mapGetters(["categorys"])
  },
  mounted() {
    if (this.category) {
      this.form.color = this.category.color;
      this.form.name = this.category.name;
      this.form.description = this.category.description;
    }
  },
  methods: {
    selectColor(value) {
      this.form.color = value.hex;
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.category) {
            this.updatedCategory({ id: this.category.id, ...this.form });
            this.$message.success("已保存");
          } else {
            this.createCategory(this.form);
            this.$message.success("添加完成");
          }

          this.$emit("create");
          this.$refs.form.resetFields();
        } else {
          this.$message.error("数据错误");

          return false;
        }
      });
    },
    getCategorys() {
      console.log("34");
    },
    ...mapActions(["createCategory", "updatedCategory"])
  }
};
</script>

<style>
.vc-compact-color-item {
  border-radius: 10rem;
}
</style>
